interface AccessErrorViewProps {
  message: string;
  onSignOut: () => void;
}

export function AccessErrorView({ message, onSignOut }: AccessErrorViewProps) {
  return (
    <section aria-labelledby="access-error-heading">
      <h2 id="access-error-heading">We couldn&rsquo;t sign you in</h2>
      <p role="alert">{message}</p>
      <button type="button" onClick={onSignOut} style={{ minHeight: 44, padding: '0.6rem 1rem', cursor: 'pointer' }}>
        Sign out and try again
      </button>
    </section>
  );
}
